export function onboardingNudgePresentation({ visible, pluginOrigin, connectionTransitionActive } = {}) {
  return {
    show: Boolean(visible && !connectionTransitionActive),
    showPluginActions: Boolean(pluginOrigin),
  };
}

// TASK (2026-09-11, bare-brand-prompts #3): once the bare-workspace nudge is
// visible — isBareWorkspace(brand), now checked on ANY plan, not only
// Posting (OnboardingNudge.jsx's check()) — this decides its copy: Posting
// keeps its existing "prepare your brand, optional" wording verbatim; every
// other plan points to the interview at /onboarding, the same destination
// (and copy) the true "missing brand" nudge already uses, and also offers
// the "Post without a brand" quick-brand opt-out that Posting doesn't have.
export function onboardingNudgeCopy(postingPlan) {
  return postingPlan
    ? { titleKey: 'postingWorkspace.nudgeTitle', ctaKey: 'postingWorkspace.prepareBrandCta', showQuickBrandCta: false }
    : { titleKey: 'onboardingNudge.title', ctaKey: 'onboardingNudge.continueCta', showQuickBrandCta: true };
}
